import React from 'react';
import { TimePicker } from '@/components/ui/TimePicker';

interface TimePickerSecondsProps {
  value?: number; // em segundos
  onChange: (seconds: number | undefined) => void;
  maxDuration?: number;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
}

export function TimePickerSeconds({ 
  value, 
  onChange, 
  maxDuration,
  disabled,
  placeholder,
  className 
}: TimePickerSecondsProps) {
  // Converter segundos para mm:ss
  const formatSecondsToTime = (seconds?: number): string => {
    if (!seconds) return '00:00';
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  // Converter mm:ss para segundos
  const parseTimeToSeconds = (timeStr: string): number => {
    const [mins, secs] = timeStr.split(':').map(Number);
    return (mins * 60) + secs;
  };

  const handleChange = (timeStr: string) => {
    if (!timeStr || timeStr === '00:00') {
      onChange(undefined);
      return;
    }
    const seconds = parseTimeToSeconds(timeStr);
    onChange(seconds);
  };

  return (
    <TimePicker
      value={formatSecondsToTime(value)}
      onChange={handleChange}
      maxDuration={maxDuration}
      disabled={disabled}
      placeholder={placeholder}
      className={className}
    />
  );
}
